import React from 'react';

function TagSolid(props) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M9.34832 2.25879H4.13416C3.09898 2.25879 2.25916 3.09861 2.25916 4.13379V9.34796C2.25916 10.176 2.58815 10.9706 3.17349 11.557L12.808 21.1924C13.5405 21.9248 14.727 21.9248 15.4594 21.1924L21.192 15.459C21.9243 14.7267 21.9243 13.5401 21.1919 12.8077L11.5578 3.17351C10.971 2.58778 10.1763 2.25879 9.34832 2.25879ZM8.50916 7.25879C8.50916 6.56879 7.94916 6.00879 7.25916 6.00879C6.56916 6.00879 6.00916 6.56879 6.00916 7.25879C6.00916 7.94879 6.56916 8.50879 7.25916 8.50879C7.94916 8.50879 8.50916 7.94879 8.50916 7.25879Z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default TagSolid;
